import type { Maybe } from '@adornis/base/utilTypes.js';
import type { RouteOptimizationResult } from '../entities/RouteOptimizationResult.js';

export const isEngineerWithoutTickets = (
  selectedPlanning: Maybe<RouteOptimizationResult>,
  engineer: { id?: string | null; name?: string | null },
) => {
  return !selectedPlanning?.routes.find(r => r.vehicleId === engineer.id);
};

export function getFieldEngineersWithoutRoutes(selectedPlanning: Maybe<RouteOptimizationResult>) {
  return (selectedPlanning?.fieldEngineersAvailable ?? [])
    .filter(fe => isEngineerWithoutTickets(selectedPlanning, fe))
    .sort((a, b) => `${a.name ?? a.id ?? ''}`.localeCompare(`${b.name ?? b.id ?? ''}`));
}

export function getFieldEngineersWithoutRoutesWithCoords(selectedPlanning: Maybe<RouteOptimizationResult>) {
  return (selectedPlanning?.fieldEngineersAvailableWithCoords ?? []).filter(fe =>
    isEngineerWithoutTickets(selectedPlanning, fe),
  );
}
